// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"style_ModalContainer__2jKxo","Tags":"style_Tags__28EKz","Tag":"style_Tag__2S4CG","ConfirmBtn":"style_ConfirmBtn__1qAY5"};